import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import {HttpClientModule} from "@angular/common/http"

import { IndexComponent } from "./pages/index/index.component";
//import { ProfilepageComponent } from "./pages/examples/profilepage/profilepage.component";
//import { RegisterpageComponent } from "./pages/examples/registerpage/registerpage.component";
import { InstitucionalComponent } from "./pages/examples/institucional/institucional.component";
import { LandingpageComponent } from "./pages/examples/landingpage/landingpage.component";
import { PrestadoresComponent } from "./pages/examples/prestadores/prestadores.component";
import { AfiliadosComponent } from "./pages/examples/afiliados/afiliados.component";
import { ServiciosComponent } from "./pages/examples/servicios/servicios.component";
import { TelefonosComponent } from './pages/examples/telefonos/telefonos.component';
import { HorariosComponent } from './pages/examples/horarios/horarios.component';
import { DecomComponent } from './pages/examples/decom/decom.component';
import { Prestadores } from './pages/examples/prestadores/prestadores.service';
//import { HeaderComponent } from './header/header.component';
//import { FooterComponent } from './footer/footer.component';


@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,   
    HttpClientModule, 
    RouterModule
  ],
  providers: [Prestadores],
  exports: []
})
export class AppRoutingModule {}
